export default __webpack_public_path__ + "static/media/discord.2ffb4415.svg";